import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
import styled, { css } from 'styled-components';
import Button from '../Button';
import TextArea from '../TextArea';
export var StickyContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  left: 0 !important;\n  bottom: 0 !important;\n  z-index: 9999;\n  width: 100%;\n  border-top: ", ";\n  background: ", ";\n\n  @media screen and (max-width: 768px) {\n    height: 100vh;\n    border-top: none;\n    top: 0;\n    left: auto;\n    transform: none;\n    padding-top: 72px;\n  }\n\n  @media screen and (max-height: 600px) and (max-width: 768px){\n    padding-top: 56px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.NPSWidget.stickyContainer.borderTop;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.NPSWidget.stickyContainer.background;
});
export var NPSContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  ", "\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.NPSWidget.container.padding;
}, function (_ref4) {
  var hasRating = _ref4.hasRating;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), hasRating && 'padding-bottom: 0;');
});
export var CloseButton = styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n  background-color: #FFF;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 9999;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media screen and (max-width: 768px) {\n    top: 20px;\n    right: 20px;\n  }\n"])));
export var Title = styled.h2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  color: ", ";\n  font-weight: 600;\n  text-align: center;\n\n  @media screen and (max-width: 768px) {\n    padding: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.NPSWidget.title.fonts;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.NPSWidget.title.fontsFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.NPSWidget.title.color;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.NPSWidget.title.responsive.padding;
});
export var RatingContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  flex-direction: row;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), theme.NPSWidget.ratingContainer.margin);
});
export var RatingMiddleContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  @media screen and (max-width: 340px) {\n    padding: 32px 4px;\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 341px) and (max-width: 360px) {\n    padding: 32px 24px;\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 361px) and (max-width: 380px) {\n    padding: 32px 30px;\n    margin: 0 auto;\n  }\n\n  @media screen and (min-width: 381px) and (max-width: 768px) {\n    padding: 32px 50px;\n    margin: 0 auto;\n  }\n"])));
export var RatingLabel = styled.p(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  display: inline;\n  color: ", ";\n  margin: ", " ", ";\n\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.NPSWidget.ratingLabel.fonts;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.NPSWidget.ratingLabel.fontsFamily;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.NPSWidget.ratingLabel.color;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.NPSWidget.ratingLabel.marginY;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.NPSWidget.ratingLabel.marginX;
});
export var ReponsiveRatingLabel = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  color: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  padding: 0 ", ";\n  text-align: center;\n  display: none;\n\n  @media screen and (max-width: 768px) {\n    display: inline-block;\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.NPSWidget.ratingLabel.fonts;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.NPSWidget.ratingLabel.fontsFamily;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.NPSWidget.ratingLabel.color;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.NPSWidget.ratingLabel.responsive.marginTop;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.NPSWidget.ratingLabel.responsive.marginBottom;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.NPSWidget.ratingLabel.responsive.paddingX;
});
export var RatingButton = styled.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  font-weight: 600;\n  font-family: ", ";\n  color: ", ";\n  padding: ", ";\n  border: ", ";\n  border-radius: ", ";\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  box-shadow: ", ";\n\n  &:hover {\n    color: ", ";\n    border: ", ";\n    cursor: pointer;\n    box-shadow: 0px 12px 26px -4px rgba(153, 102, 255, 0.5);\n  }\n\n  & + button {\n    margin-left: ", ";\n  }\n\n  @media screen and (max-width: 768px) {\n    height: ", ";\n    width: ", ";\n    margin-bottom: ", ";\n    margin-left: ", " !important;\n\n    &:nth-child(n + 6){\n      margin-left: 0;\n    }\n  }\n"])), function (_ref21) {
  var theme = _ref21.theme;
  return theme.NPSWidget.ratingButton.fonts;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.NPSWidget.ratingButton.fontsFamily;
}, function (_ref23) {
  var theme = _ref23.theme,
    selected = _ref23.selected;
  return selected ? theme.NPSWidget.ratingButton.colorSelected : theme.NPSWidget.ratingButton.color;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.NPSWidget.ratingButton.padding;
}, function (_ref25) {
  var theme = _ref25.theme,
    selected = _ref25.selected;
  return selected ? theme.NPSWidget.ratingButton.borderSelected : theme.NPSWidget.ratingButton.border;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.NPSWidget.ratingButton.borderRadius;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.NPSWidget.ratingButton.size;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.NPSWidget.ratingButton.size;
}, function (_ref29) {
  var theme = _ref29.theme,
    selected = _ref29.selected;
  return selected ? theme.NPSWidget.ratingButton.backgroundSelected : 'transparent';
}, function (_ref30) {
  var selected = _ref30.selected;
  return selected ? '0px 12px 26px -4px rgba(153, 102, 255, 0.5)' : 'none';
}, function (_ref31) {
  var theme = _ref31.theme,
    selected = _ref31.selected;
  return selected ? theme.NPSWidget.ratingButton.colorSelected : theme.NPSWidget.ratingButton.hoverColor;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.NPSWidget.ratingButton.hoverBorder;
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.NPSWidget.ratingButton.margin;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.NPSWidget.ratingButton.responsive.size;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.NPSWidget.ratingButton.responsive.size;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.NPSWidget.ratingButton.responsive.margin;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.NPSWidget.ratingButton.responsive.margin;
});
export var ReasonContainer = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: ", ";\n  max-height: ", ";\n  overflow-y: hidden;\n  transition: max-height 0.35s ease-out;\n\n  @media screen and (max-width: 768px) {\n    margin: ", " -24px;\n    width: calc(100% + 48px);\n  }\n"])), function (_ref38) {
  var theme = _ref38.theme,
    open = _ref38.open;
  return open ? theme.NPSWidget.reasonContainer.marginTop : 0;
}, function (_ref39) {
  var open = _ref39.open;
  return open ? '160px' : '0';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.NPSWidget.reasonContainer.marginTop;
});
export var ReasonTextArea = styled(TextArea)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  height: 64px;\n  padding-top: ", ";\n  ", ";\n\n  &::placeholder {\n    ", ";\n  }\n\n  @media screen and (max-width: 768px) {\n    ", ";\n    font-family: ", ";\n\n    &::placeholder {\n      ", ";\n    }\n  }\n"])), function (_ref41) {
  var theme = _ref41.theme;
  return theme.NPSWidget.reasonTextArea.wrapper.paddingTop;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.NPSWidget.reasonTextArea.wrapper.fonts;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.NPSWidget.reasonTextArea.wrapper.fonts;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.NPSWidget.reasonTextArea.responsive.fonts;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.NPSWidget.reasonTextArea.responsive.fontFamily;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.NPSWidget.reasonTextArea.responsive.fonts;
});
export var SubmitButton = styled(Button)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  width: 146px;\n\n  @media screen and (max-width: 768px) {\n    margin-bottom: ", ";\n  }\n\n"])), function (_ref47) {
  var theme = _ref47.theme;
  return theme.NPSWidget.submitButton.marginTop;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.NPSWidget.submitButton.marginBottom;
}, function (_ref49) {
  var theme = _ref49.theme;
  return theme.NPSWidget.submitButton.responsive.marginBottom;
});
export var FeedbackContainer = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n"])), function (_ref50) {
  var theme = _ref50.theme;
  return theme.NPSWidget.feedbackContainer.padding;
});
export var FeedbackTitle = styled.h2(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: ", ";\n"])), function (_ref51) {
  var theme = _ref51.theme;
  return theme.NPSWidget.feedbackTitle.fonts;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.NPSWidget.feedbackTitle.color;
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.NPSWidget.feedbackTitle.marginBottom;
});
export var FeedbackText = styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  text-align: center;\n"])), function (_ref54) {
  var theme = _ref54.theme;
  return theme.NPSWidget.feedbackText.fonts;
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.NPSWidget.feedbackText.color;
});